import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

import * as color from '../../color'

/** Displays a labeled tag with predefined or custom colors. */
@ngCore.Component({
  imports: [ngCommon.NgClass],
  selector: 'atn-ds-tag',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link color.Legacy.PredefinedStyle} */
  public readonly PredefinedStyleEnum = color.Legacy.PredefinedStyle
  /**
   * @default Legacy.PredefinedStyle.Primary
   * @see {@link color.Legacy.PredefinedStyle}
   */
  public readonly styleSg = ngCore.input<
    color.Legacy.PredefinedStyle | undefined
  >(color.Legacy.PredefinedStyle.Primary, { alias: 'style' })
  /**
   * Optional hex color that overrides the predefined tag color.
   *
   * The same color is used with 30% opacity for the tag background.
   */
  public readonly colorSg = ngCore.input<string | null | undefined>(undefined, {
    alias: 'color',
  })
  /** Background color derived from {@link colorSg}. */
  public readonly backgroundColorSg = ngCore.computed(
    (customColor = this.colorSg()) =>
      customColor ? `${customColor}4D` : undefined,
  )
  /**
   * Text to display in the tag
   */
  public readonly textSg = ngCore.input.required<string | undefined>({
    alias: 'text',
  })

  /**
   * Indicates whether the tag is currently selected.
   */
  public readonly selectedSg = ngCore.input<boolean>(false, {
    alias: 'isSelected',
  })

  /** Emits when the tag is clicked. */
  @ngCore.Output()
  public readonly click = new ngCore.EventEmitter<void>()

  /** Emits when the close control is clicked. */
  @ngCore.Output()
  public readonly close = new ngCore.EventEmitter<void>()

  /**
   * Emits click if the tag is clickable
   */
  public clickHandler() {
    this.click.emit()
  }
}
